<template>
  <div class="contact-form">
    <h2>{{ title }}</h2>
    <p class="form-desc">{{ description }}</p>

    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
      </el-form-item>

      <el-form-item label="电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入您的电子邮箱"></el-input>
      </el-form-item>

      <el-form-item label="公司" prop="company">
        <el-input v-model="form.company" placeholder="请输入您的公司名称"></el-input>
      </el-form-item>

      <el-form-item label="需求类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择咨询类型" style="width: 100%">
          <el-option label="产品咨询" value="产品咨询"></el-option>
          <el-option label="技术支持" value="技术支持"></el-option>
          <el-option label="合作洽谈" value="合作洽谈"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="留言" prop="message">
        <el-input
          type="textarea"
          v-model="form.message"
          placeholder="请详细描述您的需求或问题"
          :rows="4"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('form')" disabled :loading="loading">提交</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios'

// 创建 axios 实例
const instance = axios.create({
  baseURL: 'http://localhost:8090',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  name: 'ContactForm',
  props: {
    title: {
      type: String,
      default: '在线咨询'
    },
    description: {
      type: String,
      default: '填写以下表单，我们的专业团队将尽快与您联系。'
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        phone: '',
        email: '',
        company: '',
        type: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择需求类型', trigger: 'change' }
        ],
        message: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
          { min: 10, max: 500, message: '长度在 10 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          // 构造请求参数
          const params = {
            name: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            companyName: this.form.company,
            requirementType: this.form.type,
            leaveMessage: this.form.message
          };

          // 发送请求
          instance.post('/website/insert', params)
            .then(response => {
              if (response.data.code === 1) {
                this.$message({
                  message: '提交成功，我们将尽快与您联系！',
                  type: 'success'
                });
                this.resetForm(formName);
                this.$emit('submit-success');
              } else {
                this.$message.error(response.data.message || '提交失败，请稍后重试');
              }
            })
            .catch(error => {
              if (error.response) {
                // 服务器返回了错误状态码
                this.$message.error(`提交失败: ${error.response.data.message || '请稍后重试'}`);
              } else if (error.request) {
                // 请求发送了但没有收到响应
                this.$message.error('服务器无响应，请检查网络连接');
              } else {
                // 请求配置出错
                this.$message.error('请求配置错误，请稍后重试');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.$message.error('请正确填写表单信息');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.contact-form {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  padding: 30px;
  margin-bottom: 30px;
  height: 100%;
}

.contact-form h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 1.8rem;
}

.form-desc {
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
}
</style>
